import api from '../config/api';

/**
 * Driver Documents Service
 * Endpoints:
 * - List/filter: GET /api/driver-documents?driver_id=&limit=&offset=&document_type=
 * - Get all docs for driver: GET /api/driver-documents/driver/{driverId}
 * - Get single: GET /api/driver-documents/{documentId}
 * - Create: POST /api/driver-documents (multipart/form-data)
 * - Update: PUT /api/driver-documents/{documentId} (multipart/form-data)
 * - Delete: DELETE /api/driver-documents/{documentId}
 * - Expiring: GET /api/driver-documents/expiring
 */

export const listDriverDocuments = async (params = {}) => {
  try {
    const response = await api.get('/api/driver-documents', { params });
    return response.data || response;
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to list driver documents. Please try again.';
    throw new Error(errorMessage);
  }
};

export const getDriverDocuments = async (driverId) => {
  try {
    if (!driverId) return [];
    // Prefer dedicated driver route
    try {
      const res = await api.get(`/api/driver-documents/driver/${driverId}`);
      return res.data?.data || res.data || res;
    } catch (primaryErr) {
      // Fallback to query-style listing
      const res2 = await api.get('/api/driver-documents', { params: { driver_id: driverId, limit: 50, offset: 0 } });
      return res2.data?.data || res2.data || res2;
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to fetch driver documents. Please try again.';
    throw new Error(errorMessage);
  }
};

export const getDriverDocumentById = async (documentId) => {
  try {
    const res = await api.get(`/api/driver-documents/${documentId}`);
    return res.data || res;
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to fetch driver document. Please try again.';
    throw new Error(errorMessage);
  }
};

export const createDriverDocument = async (formData) => {
  try {
    const res = await api.post('/api/driver-documents', formData, {
      headers: { Accept: 'application/json' }
    });
    return res.data || res;
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to create driver document. Please try again.';
    throw new Error(errorMessage);
  }
};

export const updateDriverDocument = async (documentId, formData) => {
  try {
    const res = await api.put(`/api/driver-documents/${documentId}`, formData, {
      headers: { Accept: 'application/json' }
    });
    return res.data || res;
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to update driver document. Please try again.';
    throw new Error(errorMessage);
  }
};

export const deleteDriverDocument = async (documentId) => {
  try {
    const res = await api.delete(`/api/driver-documents/${documentId}`);
    return res.data || res;
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to delete driver document. Please try again.';
    throw new Error(errorMessage);
  }
};

export const getExpiringDriverDocuments = async () => {
  try {
    const res = await api.get('/api/driver-documents/expiring');
    return res.data?.data || res.data || res;
  } catch (error) {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Failed to fetch expiring driver documents. Please try again.';
    throw new Error(errorMessage);
  }
};


